<template>
    <router-link :to="`${clientRoute}/edit/${row.id}/`" class="link text-primary ripple">
        {{ tableValue }}
  </router-link>
</template>
<script>
export default {
  name: 'grid-cell-number',
  props: {
    col: Object,
    row: Object,
    clientRoute: String,
    resource: String,
    value: {
      default: () => ''
    }
  },
  computed: {
    tableValue () {
      if (typeof this.value === 'object' && this.value !== null) {
        if (this.value.hasOwnProperty('label')) {
          return this.value.label
        }
      }
      if (Array.isArray(this.value)) {
        if (this.value.length > 0) {
          return this.value[0]
        }
      }
      return this.value
    }
  }
}
</script>
